// removed by extract-text-webpack-plugin
module.exports = {"vpBrandingPreviewContainer":"vpBrandingPreviewContainer___MWgij","vpBrandingFrame":"vpBrandingFrame___3WLzX"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpVideoBrandingPreview/VpVideoBrandingPreview.module.less
// module id = 3420
// module chunks = 33